import React from 'react';
import { Helmet } from 'react-helmet';
import TopNavigation from '../../components/TopNavigation';
import Footer from '../../components/Footer';
import ContactHeroSection from './components/ContactHeroSection';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - Sleeve</title>
        <meta
          name="description"
          content="Get in touch with Sleeve or book a demo to see how we can help your team with engineering coordination." />

        <meta property="og:title" content="Contact Sleeve" />
        <meta property="og:description" content="Get in touch or book a demo" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <TopNavigation />

        {/* Hero Section with Integrated Forms */}
        <ContactHeroSection />

        <Footer />
      </div>
    </>
  );
};

export default Contact;